module.exports = __webpack_public_path__ + "static/media/senthalan_croped.405b0a1d.png";